import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconKeyboard';
/** Renders an SVG icon. */
const SvgKeyboard = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 9a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm7 13a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1"
      />
      <path
        fill="currentColor"
        d="M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      />
    </svg>
  );
};
SvgKeyboard.displayName = displayName;
export default SvgKeyboard;
